export const FETCH_BANKS_TYPE = 'PAYMENTS/BANK_TRANSFER/FETCH_BANKS'
export const SET_FETCHING_BANKS_TYPE = 'PAYMENTS/BANK_TRANSFER/SET_FETCHING_BANKS_TYPE'
export const SET_FETCH_BANKS_ERROR_TYPE = 'PAYMENTS/BANK_TRANSFER/SET_FETCH_BANKS_ERROR_TYPE'
export const SET_BANKS_TYPE = 'PAYMENTS/BANK_TRANSFER/SET_BANKS_TYPE'

export const FETCH_BANK_TYPE = 'PAYMENTS/BANK_TRANSFER/FETCH_BANK'
export const SET_FETCHING_BANK_TYPE = 'PAYMENTS/BANK_TRANSFER/SET_FETCHING_BANK_TYPE'
export const SET_FETCH_BANK_ERROR_TYPE = 'PAYMENTS/BANK_TRANSFER/SET_FETCH_BANK_ERROR_TYPE'
export const SET_BANK_TYPE = 'PAYMENTS/BANK_TRANSFER/SET_BANK_TYPE'

export const SET_BANK_SETTLEMENT_TYPE = 'PAYMENTS/BANK_TRANSFER/SET_BANK_SETTLEMENT_TYPE'
export const FETCH_BANK_SETTLEMENT = 'PAYMENTS/BANK_TRANSFER/FETCH_BANK_SETTLEMENT'
export const CLEAR_BANK_SETTLEMENT = 'PAYMENTS/BANK_TRANSFER/CLEAR_BANK_SETTLEMENT'

export const CREATE_BANK_LINK = 'PAYMENTS/BANK_TRANSFER/CREATE_BANK_LINK'
export const CREATE_BANK_LINK_SUCCES = 'PAYMENTS/BANK_TRANSFER/CREATE_BANK_LINK_SUCCESS'

export const FETCH_BANK_LINK_TOKEN_FOR_REFRESH =
  'PAYMENTS/BANK_TRANSFER/FETCH_BANK_LINK_TOKEN_FOR_REFRESH'
export const UPDATE_BANK_LINK = 'PAYMENTS/BANK_TRANSFER/UPDATE_BANK_LINK'
export const UPDATE_BANK_LINK_SUCCES = 'PAYMENTS/BANK_TRANSFER/UPDATE_BANK_LINK_SUCCESS'

export const BLOCK_BANK = 'PAYMENTS/BANK_TRANSFER/BLOCK_BANK'
export const BLOCK_BANK_SUCCESS = 'PAYMENTS/BANK_TRANSFER/BLOCK_BANK_SUCCESS'
